var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Nos actualités")]),_c('div',{staticClass:"row"},_vm._l((_vm.actualites),function(actualite){return _c('actualite',{key:actualite.id,attrs:{"actualite":actualite}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }